import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MaintenanceGuard } from './core/gaurds/maintenance.guard';
import { MaintenanceModeComponent } from './shared/components/maintenance-mode/maintenance-mode.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/PageNotFound.component';
import { ConnectionLostComponent } from './shared/components/connection-lost/connection-lost.component';

export const routes: Routes = [
    {
      path: '',
      component: MainLayoutComponent,
        canActivate: [MaintenanceGuard], // Apply MaintenanceGuard at root level
       canActivateChild: [MaintenanceGuard],
      data: { breadcrumb: 'BREADCRUMBS.HOME',showBreadcrumb: true }, // Main layout breadcrumb
      children: [
        { 
          path: '', 
          redirectTo: 'home', 
          pathMatch: 'full' 
        },
        {
          path: 'home',
          loadComponent: () =>
            import('./features/home/home.component').then(m => m.HomeComponent),
          data: { breadcrumb: null ,showBreadcrumb: false }
        },
        {
          path: 'TermsofUse/:pageId',
          loadComponent: () =>
            import('./features/home/definition-pages/definition-pages.component').then(m => m.DefinitionPagesComponent),
          data: { breadcrumb: "BREADCRUMBS.TERMS", showBreadcrumb: true }
        },
        {
          path: 'PrivacyPolicy/:pageId',
          loadComponent: () =>
            import('./features/home/definition-pages/definition-pages.component').then(m => m.DefinitionPagesComponent),
          data: { breadcrumb: "BREADCRUMBS.POLICY", showBreadcrumb: true }
        },
        {
          path: 'template',
          loadComponent: () =>
            import('./template/template.component').then(m => m.TemplateComponent),
          data: { breadcrumb: 'BREADCRUMBS.TEMPLATE',showBreadcrumb: true }
        },
        {
          path: 'teacher-add',
          loadComponent: () =>
            import('./features/teacher-add/teacher-add.component').then(m => m.TeacherAddComponent),
          data: { breadcrumb: 'BREADCRUMBS.JOIN_PLATFORM',showBreadcrumb: false }
        },
      ]
    },
    {path:"maintenance",component:MaintenanceModeComponent},
    {path:"page-not-found",component:PageNotFoundComponent},
    {path:"connection-lost",component:ConnectionLostComponent},
    {path: '**',redirectTo: 'page-not-found',pathMatch: 'full'}
  ];
  
